import styled from 'styled-components';

/* Visual tokens mirror the communicator / command-center surfaces: text
 * #0f172a, secondary #64748b, muted #94a3b8, accent #2563eb, border #e2e8f0,
 * danger #dc2626, ok #16a34a. */

export const Card = styled.div`
  width: 340px;
  max-height: 420px;
  overflow-y: auto;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.45;
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Name = styled.div`
  font-size: 15px;
  font-weight: 600;
`;

export const Contact = styled.div`
  color: #64748b;
  font-size: 12px;
  margin-top: 2px;
  word-break: break-all;
`;

export const Section = styled.div`
  margin-top: 12px;
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #5b6775;
  margin-bottom: 6px;
`;

export const GroupRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 3px 0;
`;

export const GroupName = styled.span`
  font-weight: 500;
`;

export const GroupCourse = styled.span`
  color: #5b6775;
  font-size: 12px;
`;

export const StatusTag = styled.span<{ tone: 'ok' | 'muted' | 'info' }>`
  font-size: 11px;
  padding: 0 6px;
  border-radius: 10px;
  white-space: nowrap;
  color: ${({ tone }) =>
    tone === 'ok' ? '#16651f' : tone === 'info' ? '#1d4ed8' : '#475569'};
  background: ${({ tone }) =>
    tone === 'ok' ? '#e5f6e7' : tone === 'info' ? '#dbeafe' : '#f1f5f9'};
`;

export const FlagTag = styled.span`
  font-size: 11px;
  padding: 0 6px;
  border-radius: 10px;
  white-space: nowrap;
  color: #92400e;
  background: #fef3c7;
`;

export const DebtBadge = styled.div<{ debtor: boolean }>`
  display: inline-block;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 6px;
  color: ${({ debtor }) => (debtor ? '#b91c1c' : '#16651f')};
  background: ${({ debtor }) => (debtor ? '#fee2e2' : '#e5f6e7')};
`;

export const TotalsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 6px;
  color: #475569;
  font-size: 12px;
`;

export const TotalsCell = styled.span<{ danger?: boolean }>`
  white-space: nowrap;
  ${({ danger }) => (danger ? 'color: #b91c1c; font-weight: 600;' : '')}
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
`;

export const ItemTitle = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ItemMeta = styled.span<{ overdue?: boolean }>`
  flex-shrink: 0;
  font-size: 12px;
  color: ${({ overdue }) => (overdue ? '#b91c1c' : '#94a3b8')};
`;

export const NoteBody = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #334155;
`;

export const NoteMeta = styled.div`
  color: #5b6775;
  font-size: 11px;
  margin-bottom: 4px;
`;

export const MoreHint = styled.div`
  color: #5b6775;
  font-size: 12px;
  margin-top: 2px;
`;

export const Footer = styled.div`
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
`;

export const OpenLink = styled.button`
  border: 0;
  padding: 0;
  background: none;
  cursor: pointer;
  color: #2563eb;
  font-size: 13px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const FailedWrap = styled.div`
  width: 340px;
  color: #64748b;
  font-size: 13px;
`;

export const RetryLink = styled.button`
  border: 0;
  padding: 0;
  margin-left: 6px;
  background: none;
  cursor: pointer;
  color: #2563eb;
`;

export const Muted = styled.div`
  color: #5b6775;
  font-size: 12px;
`;

/* --- thread-header summary strip ------------------------------------- */

export const Strip = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  border: 0;
  padding: 0;
  margin-top: 2px;
  background: none;
  cursor: pointer;
  font-size: 12px;
  color: #64748b;
  text-align: left;
`;

export const StripGroup = styled.span`
  white-space: nowrap;
`;

export const StripDebt = styled.span`
  white-space: nowrap;
  font-weight: 600;
  padding: 0 6px;
  border-radius: 10px;
  color: #b91c1c;
  background: #fee2e2;
`;
